
import useStyles from './style';
import "./index.css";

interface StripeConnectButtonProps {}
export const StripeConnectButton = (props: StripeConnectButtonProps) => {
    const classes = useStyles();
    
    const connectToStripe = (e: any) => {
        e.preventDefault();
        const url = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CONNECT_ID}&scope=read_write&redirect_uri=${process.env.REACT_APP_DOMAIN}/app-info`;
        window.location.replace(url);
    };

    return (
        <div  className={`${classes.containerInputPrice}`}>
            <div>Want to sell this brik?</div>
            <a href="#" className="stripe-connect" onClick={connectToStripe}><span>Connect with</span></a>
        </div>
    );
}